import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onMounted, onUnmounted, ref } from "vue";
import TooltippedText from "../tooltip/TooltippedText/TooltippedText.vue";

type ValueType = string


export default /*#__PURE__*/_defineComponent({
  __name: 'ChipsInput',
  props: {
    placeholder: { default: '' },
    disabled: { type: Boolean },
    value: null,
    smallInput: { type: Boolean },
    height: { default: 'large' }
  },
  emits: ["input", "input-change", "input-focus", "removed", "blur"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: "input", value?: Array<ValueType>): void;
  (e: "input-change", value: string): void;
  (e: "input-focus"): void;
  (e: "removed", value: string): void;
  (e: "blur"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { placeholder: string, disabled?: boolean, value?: Array<ValueType>, smallInput?: boolean, height: 'small' | 'large' };





const showTag = ref(true);
const combobox = ref();

const chips = computed({
  get: () => props.value,
  set: (newValue) => emit('input', newValue)
});

onMounted(
  async () => {
    await nextTick(() => {
      if(!combobox.value) {
        return;
      }
      const input = combobox.value.$refs.input;
      const appendedText = combobox.value.$refs['append-inner'];
      input.parentNode.appendChild(appendedText);
  
      input.addEventListener('input', change);
    });
  }
);

onUnmounted(
  () => {
    if(!combobox.value) {
        return;
      }
    const input = combobox.value.$refs.input;
    input.removeEventListener('input', change);
  }
)

function change(e: InputEvent) {
  emit('input-change', (e.target as HTMLInputElement).value);
}

function focus() {
  showTag.value = false;
  emit('input-focus');
}

function blur() {
  showTag.value = true;

  emit("blur");
}

function remove(item: string) {
  chips.value = chips.value && chips.value.filter(c => c !== item);
  showTag.value = false;
  emit('removed', item);
}

expose({ focus });

return { __sfc: true,props, emit, showTag, combobox, chips, change, focus, blur, remove, TooltippedText }
}

})